"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _tree = require("./tree");
// i18next-extract-mark-ns-start Trees

var getTreePackage = function getTreePackage(t) {
  var pricingVersion = (0, _tree.getPricingVersion)();
  return [{
    name: t('Pantalon'),
    slug: 'pant',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'hem',
        label: t('Faire un ourlet'),
        question: t('À quel endroit est-il trop grand ?'),
        locations: [{
          slug: 'hem',
          label: t('Sur la longueur'),
          id: "".concat(pricingVersion, ".pant-ret-rac-1")
        }]
      }, {
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'pocket',
          label: t('Une poche est trouée'),
          id: "".concat(pricingVersion, ".pant-rep-tear-1"),
          multiple: true
        }, {
          slug: 'pockets',
          label: t('Changer le rabat des poches'),
          id: "".concat(pricingVersion, ".pant-rep-tear-3")
        }, {
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".pant-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".pant-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".pant-rep-tear-1"),
          multiple: true
        }]
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'pocket',
          label: t('Une poche est trouée'),
          id: "".concat(pricingVersion, ".pant-rep-tear-1"),
          multiple: true
        }, {
          slug: 'pockets',
          label: t('Changer le rabat des poches'),
          id: "".concat(pricingVersion, ".pant-rep-tear-3")
        }, {
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".pant-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".pant-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".pant-rep-tear-1"),
          multiple: true
        }, {
          slug: 'unraveledHem2',
          label: t('L‘ourlet est décousu (x2 jambes)'),
          id: "".concat(pricingVersion, ".pant-rep-div-7")
        }]
      }]
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }]
  }, {
    name: t('Manteau & veste'),
    slug: 'mant',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'hem',
        label: t('Faire un ourlet'),
        question: t('À quel endroit est-il trop grand ?'),
        locations: [{
          slug: 'hem',
          label: t('Sur la longueur'),
          id: "".concat(pricingVersion, ".mant-ret-rac-1")
        }]
      }, {
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'entireLining',
          label: t('Sur toute la doublure'),
          id: "".concat(pricingVersion, ".mant-rep-div-3")
        }, {
          slug: 'liningPart',
          label: t('Sur une partie de la doublure'),
          id: "".concat(pricingVersion, ".mant-rep-div-2")
        }, {
          slug: 'pocket',
          label: t('Une poche est trouée'),
          id: "".concat(pricingVersion, ".mant-rep-tear-1"),
          multiple: true
        }, {
          slug: 'pockets',
          label: t('Changer le rabat des poches'),
          id: "".concat(pricingVersion, ".mant-rep-tear-3")
        }, {
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".mant-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".mant-rep-zip-3"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".mant-rep-tear-1"),
          multiple: true
        }, {
          slug: 'reinforcement',
          label: t('Il nécessite un renfort'),
          id: "".concat(pricingVersion, ".mant-rep-tear-2"),
          multiple: true
        }]
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'entireLining',
          label: t('Sur toute la doublure'),
          id: "".concat(pricingVersion, ".mant-rep-div-3")
        }, {
          slug: 'liningPart',
          label: t('Sur une partie de la doublure'),
          id: "".concat(pricingVersion, ".mant-rep-div-2")
        }, {
          slug: 'pocket',
          label: t('Une poche est trouée'),
          id: "".concat(pricingVersion, ".mant-rep-tear-1"),
          multiple: true
        }, {
          slug: 'pockets',
          label: t('Changer le rabat des poches'),
          id: "".concat(pricingVersion, ".mant-rep-tear-3")
        }, {
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".mant-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".mant-rep-zip-3"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".mant-rep-tear-1"),
          multiple: true
        }, {
          slug: 'reinforcement',
          label: t('Il nécessite un renfort'),
          id: "".concat(pricingVersion, ".mant-rep-tear-2"),
          multiple: true
        }]
      }]
    }]
  }, {
    name: t('Robe'),
    slug: 'robe',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'hem',
        label: t('Faire un ourlet'),
        question: t('À quel endroit est-elle trop grande ?'),
        locations: [{
          slug: 'hem',
          label: t('Sur la longueur'),
          id: "".concat(pricingVersion, ".robe-ret-rac-1")
        }]
      }, {
        slug: 'tooLargeSling',
        label: t('Raccourcir les bretelles'),
        question: t('À quel endroit est-elle trop grande ?'),
        locations: [{
          slug: 'tooLargeSling',
          label: t('Au niveau des bretelles'),
          id: "".concat(pricingVersion, ".robe-ret-rac-6")
        }]
      }, {
        slug: 'damaged',
        label: t('Elle est abîmée'),
        question: t('À quel endroit est-elle abîmée ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".robe-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".robe-rep-zip-5"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Elle est déchirée / trouée'),
          id: "".concat(pricingVersion, ".robe-rep-tear-1"),
          multiple: true
        }]
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Elle est abîmée'),
        question: t('À quel endroit est-elle abîmée ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".robe-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".robe-rep-zip-5"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Elle est déchirée / trouée'),
          id: "".concat(pricingVersion, ".robe-rep-tear-1"),
          multiple: true
        }, {
          slug: 'unraveledHem',
          label: t('L‘ourlet est décousu'),
          id: "".concat(pricingVersion, ".robe-rep-div-6")
        }]
      }]
    }]
  }, {
    name: t('Haut'),
    slug: 'haut',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'hem',
        label: t('Faire un ourlet'),
        question: t('À quel endroit est-il trop grand ?'),
        locations: [{
          slug: 'hem',
          label: t('Sur la longueur'),
          id: "".concat(pricingVersion, ".haut-ret-rac-1")
        }]
      }, {
        slug: 'tooLargeSling',
        label: t('Raccourcir les bretelles'),
        question: t('À quel endroit est-il trop grand ?'),
        locations: [{
          slug: 'tooLargeSling',
          label: t('Au niveau des bretelles'),
          id: "".concat(pricingVersion, ".haut-rac-7")
        }]
      }, {
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".haut-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".haut-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".haut-rep-tear-1"),
          multiple: true
        }, {
          slug: 'reinforcement',
          label: t('Il nécessite un renfort'),
          id: "".concat(pricingVersion, ".haut-rep-tear-2"),
          multiple: true
        }]
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".haut-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".haut-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".haut-rep-tear-1"),
          multiple: true
        }, {
          slug: 'reinforcement',
          label: t('Il nécessite un renfort'),
          id: "".concat(pricingVersion, ".haut-rep-tear-2"),
          multiple: true
        }]
      }]
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }]
  }, {
    name: t('Jupe'),
    slug: 'jupe',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'hem',
        label: t('Faire un ourlet'),
        question: t('À quel endroit est-elle trop grande ?'),
        locations: [{
          slug: 'hem',
          label: t('Sur la longueur'),
          id: "".concat(pricingVersion, ".jupe-ret-rac-1")
        }]
      }, {
        slug: 'damaged',
        label: t('Elle est abîmée'),
        question: t('À quel endroit est-elle abîmée ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".jupe-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".jupe-rep-zip-4"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Elle est déchirée / trouée'),
          id: "".concat(pricingVersion, ".jupe-rep-tear-1"),
          multiple: true
        }, {
          slug: 'reinforcement',
          label: t('Elle nécessite un renfort'),
          id: "".concat(pricingVersion, ".jupe-rep-tear-2"),
          multiple: true
        }]
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Elle est abîmée'),
        question: t('À quel endroit est-elle abîmée ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".jupe-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".jupe-rep-zip-4"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Elle est déchirée / trouée'),
          id: "".concat(pricingVersion, ".jupe-rep-tear-1"),
          multiple: true
        }, {
          slug: 'reinforcement',
          label: t('Elle nécessite un renfort'),
          id: "".concat(pricingVersion, ".jupe-rep-tear-2"),
          multiple: true
        }, {
          slug: 'unraveledHem',
          label: t('L‘ourlet est décousu'),
          id: "".concat(pricingVersion, ".jupe-rep-div-6")
        }]
      }]
    }]
  }, {
    name: t('Pull & gilet'),
    slug: 'pull',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".pull-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".pull-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".pull-rep-tear-1"),
          multiple: true
        }, {
          slug: 'reinforcement',
          label: t('Il nécessite un renfort'),
          id: "".concat(pricingVersion, ".pull-rep-tear-2"),
          multiple: true
        }]
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".pull-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".pull-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".pull-rep-tear-1"),
          multiple: true
        }, {
          slug: 'reinforcement',
          label: t('Il nécessite un renfort'),
          id: "".concat(pricingVersion, ".pull-rep-tear-2"),
          multiple: true
        }]
      }]
    }]
  }, {
    name: t('Lingerie'),
    slug: 'ling',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'tooLargeSling',
        label: t('Raccourcir les bretelles'),
        question: t('À quel endroit est-elle trop grande ?'),
        locations: [{
          slug: 'tooLargeSling',
          label: t('Au niveau des bretelles'),
          id: "".concat(pricingVersion, ".ling-ret-rac-1")
        }]
      }, {
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'damagedElastic',
          label: t('Changement de l’élastique'),
          id: "".concat(pricingVersion, ".ling-ret-div-6"),
          multiple: true
        }, {
          slug: 'damagedWhale',
          label: t('Changement des baleines'),
          id: "".concat(pricingVersion, ".ling-rep-div-3"),
          multiple: true
        }, {
          slug: 'damagedSling',
          label: t('Changement des bretelles'),
          id: "".concat(pricingVersion, ".ling-ret-div-14")
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".ling-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".ling-rep-tear-1"),
          multiple: true
        }]
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'damagedElastic',
          label: t('Changement de l’élastique'),
          id: "".concat(pricingVersion, ".ling-ret-div-6"),
          multiple: true
        }, {
          slug: 'damagedWhale',
          label: t('Changement des baleines'),
          id: "".concat(pricingVersion, ".ling-rep-div-3"),
          multiple: true
        }, {
          slug: 'damagedSling',
          label: t('Changement des bretelles'),
          id: "".concat(pricingVersion, ".ling-ret-div-14")
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".ling-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".ling-rep-tear-1"),
          multiple: true
        }]
      }]
    }]
  }, {
    name: t('Combinaison'),
    slug: 'comb',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'hem',
        label: t('Faire un ourlet'),
        question: t('À quel endroit est-elle trop grande ?'),
        locations: [{
          slug: 'hem',
          label: t('Sur la longueur'),
          id: "".concat(pricingVersion, ".comb-ret-rac-3")
        }]
      }, {
        slug: 'tooLargeSling',
        label: t('Raccourcir les bretelles'),
        question: t('À quel endroit est-elle trop grande ?'),
        locations: [{
          slug: 'tooLargeSling',
          label: t('Au niveau des bretelles'),
          id: "".concat(pricingVersion, ".comb-ret-rac-5")
        }]
      }, {
        slug: 'damaged',
        label: t('Elle est abîmée'),
        question: t('À quel endroit est-elle abîmée ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".comb-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".comb-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Elle est déchirée / trouée'),
          id: "".concat(pricingVersion, ".comb-rep-tear-1"),
          multiple: true
        }, {
          slug: 'pocket',
          label: t('Une poche est trouée'),
          id: "".concat(pricingVersion, ".comb-rep-tear-1"),
          multiple: true
        }, {
          slug: 'pockets',
          label: t('Changer le rabat des poches'),
          id: "".concat(pricingVersion, ".comb-rep-tear-3")
        }]
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Elle est abîmée'),
        question: t('À quel endroit est-elle abîmée ?'),
        locations: [{
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".comb-rep-but-2"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".comb-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Elle est déchirée / trouée'),
          id: "".concat(pricingVersion, ".comb-rep-tear-1"),
          multiple: true
        }, {
          slug: 'pocket',
          label: t('Une poche est trouée'),
          id: "".concat(pricingVersion, ".comb-rep-tear-1"),
          multiple: true
        }, {
          slug: 'pockets',
          label: t('Changer le rabat des poches'),
          id: "".concat(pricingVersion, ".comb-rep-tear-3")
        }, {
          slug: 'unraveledHem2',
          label: t('L‘ourlet est décousu (x2 jambes)'),
          id: "".concat(pricingVersion, ".comb-rep-div-5")
        }]
      }]
    }]
  }, {
    name: t('Maillot de bain'),
    slug: 'mail',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration',
      problems: [{
        slug: 'tooLargeSling',
        label: t('Raccourcir les bretelles'),
        question: t('À quel endroit est-il trop grand ?'),
        locations: [{
          slug: 'tooLargeSling',
          label: t('Au niveau des bretelles'),
          id: "".concat(pricingVersion, ".ling-ret-rac-1")
        }]
      }, {
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'damagedElastic',
          label: t('Changement de l’élastique'),
          id: "".concat(pricingVersion, ".ling-ret-div-6"),
          multiple: true
        }, {
          slug: 'damagedWhale',
          label: t('Changement des baleines'),
          id: "".concat(pricingVersion, ".ling-rep-div-3"),
          multiple: true
        }, {
          slug: 'damagedSling',
          label: t('Changement des bretelles'),
          id: "".concat(pricingVersion, ".ling-ret-div-14")
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".ling-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".ling-rep-tear-1"),
          multiple: true
        }]
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'damagedElastic',
          label: t('Changement de l’élastique'),
          id: "".concat(pricingVersion, ".ling-ret-div-6"),
          multiple: true
        }, {
          slug: 'damagedWhale',
          label: t('Changement des baleines'),
          id: "".concat(pricingVersion, ".ling-rep-div-3"),
          multiple: true
        }, {
          slug: 'damagedSling',
          label: t('Changement des bretelles'),
          id: "".concat(pricingVersion, ".ling-ret-div-14")
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".ling-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".ling-rep-tear-1"),
          multiple: true
        }]
      }]
    }]
  }, {
    name: t('Costume'),
    slug: 'cost',
    pieces: {
      mant: {
        name: t('Veste de costume')
      },
      pant: {
        name: t('Pantalon de costume')
      }
    },
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration'
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair'
    }]
  }, {
    name: t('Robe de mariée'),
    slug: 'mari',
    hasNoTypes: true,
    typesOfWork: []
  }, {
    name: t('Accessoire'),
    slug: 'acce',
    typesOfWork: [{
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'damagedElastic',
          label: t('Il faut changer l’élastique'),
          id: "".concat(pricingVersion, ".acce-ret-div-6"),
          multiple: true
        }, {
          slug: 'brokenZip',
          label: t('Le zip est bloqué'),
          id: "".concat(pricingVersion, ".acce-rep-zip-1"),
          multiple: true
        }, {
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".acce-rep-tear-1"),
          multiple: true
        }, {
          slug: 'button',
          label: t('Il manque un bouton'),
          id: "".concat(pricingVersion, ".acce-rep-but-2"),
          multiple: true
        }]
      }]
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }]
  }, {
    name: t('Petit accessoire'),
    slug: 'little_acce',
    typesOfWork: [{
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'tornHoley',
          label: t('Il est déchiré / troué'),
          id: "".concat(pricingVersion, ".acce-rep-tear-1"),
          multiple: true
        }]
      }]
    }]
  }, {
    name: t('Rideau'),
    slug: 'ride',
    typesOfWork: [{
      label: t('Retoucher'),
      subLabel: t('Ajuster vos pièces'),
      slug: 'alteration'
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair'
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }]
  }, {
    name: t('Drap/Housse de couette'),
    slug: 'sheet',
    typesOfWork: [{
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair'
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }]
  }, {
    name: t('Plaid & couvre lit'),
    slug: 'plaid',
    typesOfWork: [{
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair'
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }]
  }, {
    name: t('Housse de coussin'),
    slug: 'cous',
    typesOfWork: [{
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair'
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }]
  }, {
    name: t('Nappes'),
    slug: 'tableClothes',
    typesOfWork: [{
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair'
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }]
  }, {
    name: t('Serviettes'),
    slug: 'napkins',
    typesOfWork: [{
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair'
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }]
  }, {
    name: t('Housse de canapé'),
    slug: 'sofa',
    typesOfWork: [{
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair'
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }]
  }, {
    name: t('Housse de chaise'),
    slug: 'chair',
    typesOfWork: [{
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'repair'
    }, {
      label: t('Broder'),
      subLabel: t('Décorer à l’aide d’un motif'),
      slug: 'embroidery'
    }]
  }, {
    name: t('Sac'),
    slug: 'bag',
    typesOfWork: [{
      label: t('Entretenir'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'prevent',
      problems: [{
        slug: 'dirty',
        label: t('Il est sale / tâché')
      }, {
        slug: 'discolored',
        label: t('Il est usé / décoloré')
      }, {
        slug: 'waterproofing',
        label: t('Imperméabiliser'),
        locations: [{
          slug: 'waterproofing',
          id: "".concat(pricingVersion, ".bag-prevent-5")
        }]
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'cure',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'liningBag',
          label: t('Doublure'),
          question: t('Pouvez-vous préciser ?'),
          parts: [{
            slug: 'liningBag_liningPart',
            label: t('Une partie de la doublure'),
            id: "".concat(pricingVersion, ".bag-cure-14")
          }, {
            slug: 'liningBag_fullLining',
            label: t('Toute la doublure'),
            id: "".concat(pricingVersion, ".bag-cure-16")
          }]
        }, {
          slug: 'brokenZip',
          label: t('Zip'),
          id: "".concat(pricingVersion, ".bag-cure-23"),
          multiple: true
        }, {
          slug: 'handles',
          label: t('Poignées / anses'),
          id: "".concat(pricingVersion, ".bag-cure-58")
        }, {
          slug: 'shoulderStrap',
          label: t('Bandoulière'),
          id: "".concat(pricingVersion, ".bag-cure-52")
        }, {
          slug: 'eyelet',
          label: t('Oeillet / rivet'),
          id: "".concat(pricingVersion, ".bag-cure-31"),
          multiple: true
        }, {
          slug: 'clasp',
          label: t('Fermoir'),
          id: "".concat(pricingVersion, ".bag-cure-33")
        }, {
          slug: 'untidy',
          label: t('Couture décousue'),
          id: "".concat(pricingVersion, ".bag-cure-47")
        },
        // Pour les 2 suivants, un nettoyage est ajouté avec l'id: `${pricingVersion}.bag-prevent-1`
        {
          slug: 'cracked',
          label: t('Le cuir est craquelé / éraflé'),
          id: "".concat(pricingVersion, ".bag-cure-40")
        }, {
          slug: 'tornHoleyLeatherGoods',
          label: t('Le cuir est déchiré / troué'),
          id: "".concat(pricingVersion, ".bag-cure-41"),
          multiple: true
        }]
      }]
    }, {
      label: t('Recolorer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'recolor',
      message: t(
      // eslint-disable-next-line max-len
      'Pour changer la couleur de votre sac, la nouvelle couleur souhaitée doit être plus foncée que la couleur d’origine. Nous vous invitons à nous envoyer votre demande par mail, accompagnée de photos du sac, par mail à l’adresse contact@tilli.fr. Nos artisans reviendront vers vous pour vous conseiller et vous accompagner sur la meilleure couleur à adopter pour votre pièce.'),
      problems: [{
        slug: 'discolored',
        label: t('Il est décoloré')
      }, {
        slug: 'changeColor',
        label: t('Changer la teinte')
      }]
    }]
  }, {
    name: t('Ceinture'),
    slug: 'belt',
    typesOfWork: [{
      label: t('Entretenir'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'prevent',
      problems: [{
        slug: 'dirty',
        label: t('Il est sale / tâché'),
        locations: [{
          slug: 'dirty',
          id: "".concat(pricingVersion, ".belt-prevent-1")
        }]
      }, {
        slug: 'discolored',
        label: t('Il est usé / décoloré'),
        locations: [{
          slug: 'discolored',
          id: "".concat(pricingVersion, ".belt-recolor-2")
        }]
      }, {
        slug: 'waterproofing',
        label: t('Imperméabiliser'),
        locations: [{
          slug: 'waterproofing',
          id: "".concat(pricingVersion, ".belt-prevent-3")
        }]
      }, {
        slug: 'drillHole',
        label: t('Percer un trou supplémentaire'),
        locations: [{
          slug: 'drillHole',
          id: "".concat(pricingVersion, ".belt-prevent-4")
        }]
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'cure',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'clasp',
          label: t('Fermoir'),
          id: "".concat(pricingVersion, ".belt-cure-13")
        }, {
          slug: 'untidy',
          label: t('Couture décousue'),
          id: "".concat(pricingVersion, ".belt-cure-28")
        }]
      }]
    }, {
      label: t('Recolorer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'recolor',
      message: t(
      // eslint-disable-next-line max-len
      'Pour changer la couleur de votre ceinture, la nouvelle couleur souhaitée doit être plus foncée que la couleur d’origine. Nous vous invitons à nous envoyer votre demande par mail, accompagnée de photos du sac, par mail à l’adresse contact@tilli.fr. Nos artisans reviendront vers vous pour vous conseiller et vous accompagner sur la meilleure couleur à adopter pour votre pièce.'),
      problems: [{
        slug: 'discolored',
        label: t('Elle est décolorée'),
        locations: [{
          slug: 'discolored',
          id: "".concat(pricingVersion, ".belt-recolor-2")
        }]
      }, {
        slug: 'changeColor',
        label: t('Changer la teinte')
      }]
    }]
  }, {
    name: t('Portefeuille & Pochette'),
    slug: 'wallet',
    typesOfWork: [{
      label: t('Entretenir'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'prevent',
      problems: [{
        slug: 'dirty',
        label: t('Il est sale / tâché'),
        locations: [{
          slug: 'dirty',
          id: "".concat(pricingVersion, ".wallet-prevent-1")
        }]
      }, {
        slug: 'discolored',
        label: t('Il est usé / décoloré'),
        locations: [{
          slug: 'discolored',
          id: "".concat(pricingVersion, ".wallet-recolor-2")
        }]
      }, {
        slug: 'waterproofing',
        label: t('Imperméabiliser'),
        locations: [{
          slug: 'waterproofing',
          id: "".concat(pricingVersion, ".wallet-prevent-3")
        }]
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'cure',
      problems: [{
        slug: 'damaged',
        label: t('Il est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'liningWallet',
          label: t('Doublure'),
          id: "".concat(pricingVersion, ".wallet-cure-20")
        }, {
          slug: 'brokenZip',
          label: t('Zip'),
          id: "".concat(pricingVersion, ".wallet-cure-3"),
          multiple: true
        }, {
          slug: 'eyelet',
          label: t('Oeillet / rivet'),
          id: "".concat(pricingVersion, ".wallet-cure-11"),
          multiple: true
        }, {
          slug: 'clasp',
          label: t('Fermoir'),
          id: "".concat(pricingVersion, ".wallet-cure-13")
        }, {
          slug: 'untidy',
          label: t('Couture décousue'),
          id: "".concat(pricingVersion, ".wallet-cure-28")
        },
        // Pour les 2 suivants, un nettoyage est ajouté avec l'id: `${pricingVersion}.wallet-prevent-1`
        {
          slug: 'cracked',
          label: t('Le cuir est craquelé / éraflé'),
          id: "".concat(pricingVersion, ".wallet-cure-23")
        }, {
          slug: 'tornHoleyLeatherGoods',
          label: t('Le cuir est déchiré / troué'),
          id: "".concat(pricingVersion, ".wallet-cure-24"),
          multiple: true
        }]
      }]
    }, {
      label: t('Recolorer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'recolor',
      message: t(
      // eslint-disable-next-line max-len
      'Pour changer la couleur de votre accessoire, la nouvelle couleur souhaitée doit être plus foncée que la couleur d’origine. Nous vous invitons à nous envoyer votre demande par mail, accompagnée de photos du sac, par mail à l’adresse contact@tilli.fr. Nos artisans reviendront vers vous pour vous conseiller et vous accompagner sur la meilleure couleur à adopter pour votre pièce.'),
      problems: [{
        slug: 'discolored',
        label: t('Il est décoloré'),
        locations: [{
          slug: 'discolored',
          id: "".concat(pricingVersion, ".wallet-recolor-2")
        }]
      }, {
        slug: 'changeColor',
        label: t('Changer la teinte')
      }]
    }]
  }, {
    name: t('Chaussures plates'),
    slug: 'flat_shoes',
    typesOfWork: [{
      label: t('Entretenir'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'prevent',
      problems: [{
        slug: 'wax',
        label: t('Nettoyer & cirer'),
        locations: [{
          slug: 'wax',
          id: "".concat(pricingVersion, ".shoes-prevent-1")
        }]
      },
      // COMING SOON
      // {
      //   slug: 'waterproofing',
      //   label: 'Imperméabiliser',
      //   locations: [
      //     {
      //       slug: 'waterproofing',
      //       id: `${pricingVersion}.shoes-prevent-5`,
      //     },
      //   ],
      // },
      {
        slug: 'protect',
        label: t('Protéger'),
        question: t('Que souhaitez-vous poser :'),
        withImage: true,
        locations: [{
          slug: 'protect_pads',
          label: t('Des patins'),
          id: "".concat(pricingVersion, ".shoes-prevent-11"),
          image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/skatesShoes.png'
        }, {
          slug: 'protect_irons',
          label: t('Des fers'),
          id: "".concat(pricingVersion, ".shoes-prevent-12"),
          image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/ironsShoes.png'
        }, {
          slug: 'protect_padsAndIrons',
          label: t('Protection complète (patins & fers)'),
          id: "".concat(pricingVersion, ".shoes-prevent-13"),
          image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/completeShoes.png'
        }]
      }, {
        slug: 'shaping',
        label: t('Mettre en forme / Agrandir'),
        question: t('Que souhaitez-vous mettre en forme / agrandir ?'),
        locations: [{
          slug: 'shaping_width',
          label: t('La largeur'),
          id: "".concat(pricingVersion, ".shoes-prevent-8")
        }, {
          slug: 'shaping_kick',
          label: t('Le coup de pied'),
          id: "".concat(pricingVersion, ".shoes-prevent-9")
        }]
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'cure',
      problems: [{
        slug: 'damaged',
        label: t('C‘est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'dirty',
          label: t('C‘est sale / taché / décoloré'),
          id: "".concat(pricingVersion, ".shoes-prevent-1")
        }, {
          slug: 'damagedSole',
          label: t('Semelle extérieure'),
          id: "".concat(pricingVersion, ".shoes-cure-2")
        }, {
          slug: 'damagedHeel',
          label: t('Talon'),
          question: t('Que souhaitez-vous changer :'),
          parts: [{
            slug: 'damagedHeel_bonbout',
            label: t('L\'embout du talon (le bonbout)'),
            id: "".concat(pricingVersion, ".shoes-cure-7")
          }, {
            slug: 'damagedHeel_complete',
            label: t('Le talon entier'),
            id: "".concat(pricingVersion, ".shoes-cure-10")
          }]
        }, {
          slug: 'brokenZip',
          label: t('Zip'),
          id: "".concat(pricingVersion, ".shoes-cure-17"),
          multiple: true
        }, {
          slug: 'eyelet',
          label: t('Oeillets / rivets'),
          id: "".concat(pricingVersion, ".shoes-cure-19"),
          multiple: true
        }, {
          slug: 'damagedInside',
          label: t('A l‘intérieur'),
          question: t('Que souhaitez-vous changer :'),
          withImage: true,
          parts: [{
            slug: 'damagedInside_slides',
            label: t('Les glissoirs'),
            id: "".concat(pricingVersion, ".shoes-cure-15"),
            image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/slidesShoes.png'
          }, {
            slug: 'damagedInside_insole',
            label: t('La semelle intérieure'),
            id: "".concat(pricingVersion, ".shoes-cure-14"),
            image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/insoleShoes.png'
          }]
        }]
      }]
    }, {
      label: t('Rénover'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'recolor',
      message: t(
      // eslint-disable-next-line max-len
      'Pour changer la couleur de vos chaussures ou les patiner, la nouvelle couleur souhaitée doit être plus foncée que la couleur d’origine. Nous vous invitons à nous envoyer votre demande par mail, accompagnée de photos des chaussures, par mail à l’adresse contact@tilli.fr. Nos artisans reviendront vers vous pour vous conseiller et vous accompagner sur la meilleure couleur à adopter pour votre pièce.'),
      problems: [{
        slug: 'wax',
        label: t('Nettoyer & cirer'),
        locations: [{
          slug: 'wax',
          id: "".concat(pricingVersion, ".shoes-prevent-1")
        }]
      }, {
        slug: 'fullRepare',
        label: t('Rénover le cuir'),
        locations: [{
          slug: 'fullRepare',
          id: "".concat(pricingVersion, ".shoes-prevent-5")
        }]
      }, {
        slug: 'skate',
        label: t('Patiner'),
        locations: [{
          slug: 'skate',
          id: "".concat(pricingVersion, ".shoes-prevent-4")
        }]
      }, {
        slug: 'changeColor',
        label: t('Changer la teinte'),
        locations: [{
          slug: 'changeColor',
          id: ''
        }]
      }]
    }]
  }, {
    name: t('Chaussures à talon'),
    slug: 'heeled_shoes',
    typesOfWork: [{
      label: t('Entretenir'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'prevent',
      problems: [{
        slug: 'wax',
        label: t('Nettoyer & cirer'),
        locations: [{
          slug: 'wax',
          id: "".concat(pricingVersion, ".shoes-prevent-1")
        }]
      },
      // COMING SOON
      // {
      //   slug: 'waterproofing',
      //   label: 'Imperméabiliser',
      //   locations: [
      //     {
      //       slug: 'waterproofing',
      //       id: `${pricingVersion}.shoes-prevent-5`,
      //     },
      //   ],
      // },
      {
        slug: 'protect',
        label: t('Protéger'),
        question: t('Que souhaitez-vous poser :'),
        withImage: true,
        locations: [{
          slug: 'protect_pads',
          label: t('Des patins'),
          id: "".concat(pricingVersion, ".shoes-prevent-11"),
          image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/skatesShoes.png'
        }, {
          slug: 'protect_irons',
          label: t('Des fers'),
          id: "".concat(pricingVersion, ".shoes-prevent-12"),
          image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/ironsShoes.png'
        }, {
          slug: 'protect_padsAndIrons',
          label: t('Protection complète (patins & fers)'),
          id: "".concat(pricingVersion, ".shoes-prevent-13"),
          image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/completeShoes.png'
        }]
      }, {
        slug: 'shaping',
        label: t('Mettre en forme / Agrandir'),
        question: t('Que souhaitez-vous mettre en forme / agrandir ?'),
        locations: [{
          slug: 'shaping_width',
          label: t('La largeur'),
          id: "".concat(pricingVersion, ".shoes-prevent-8")
        }, {
          slug: 'shaping_kick',
          label: t('Le coup de pied'),
          id: "".concat(pricingVersion, ".shoes-prevent-9")
        }]
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'cure',
      problems: [{
        slug: 'damaged',
        label: t('C‘est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'dirty',
          label: t('C‘est sale / taché / décoloré'),
          id: "".concat(pricingVersion, ".shoes-prevent-1")
        }, {
          slug: 'damagedSole',
          label: t('Semelle extérieure'),
          id: "".concat(pricingVersion, ".shoes-cure-2")
        }, {
          slug: 'damagedHeel',
          label: t('Talon'),
          question: t('Que souhaitez-vous changer :'),
          parts: [{
            slug: 'damagedHeel_bonbout',
            label: t('L\'embout du talon (le bonbout)'),
            id: "".concat(pricingVersion, ".shoes-cure-7")
          }, {
            slug: 'damagedHeel_complete',
            label: t('Le talon entier'),
            id: "".concat(pricingVersion, ".shoes-cure-10")
          }]
        }, {
          slug: 'brokenZip',
          label: t('Zip'),
          id: "".concat(pricingVersion, ".shoes-cure-17"),
          multiple: true
        }, {
          slug: 'eyelet',
          label: t('Oeillets / rivets'),
          id: "".concat(pricingVersion, ".shoes-cure-19"),
          multiple: true
        }, {
          slug: 'damagedInside',
          label: t('A l‘intérieur'),
          question: t('Que souhaitez-vous changer :'),
          withImage: true,
          parts: [{
            slug: 'damagedInside_slides',
            label: t('Les glissoirs'),
            id: "".concat(pricingVersion, ".shoes-cure-15"),
            image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/slidesShoes.png'
          }, {
            slug: 'damagedInside_insole',
            label: t('La semelle intérieure'),
            id: "".concat(pricingVersion, ".shoes-cure-14"),
            image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/insoleShoes.png'
          }]
        }]
      }]
    }, {
      label: t('Rénover'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'recolor',
      message: t(
      // eslint-disable-next-line max-len
      'Pour changer la couleur de vos chaussures ou les patiner, la nouvelle couleur souhaitée doit être plus foncée que la couleur d’origine. Nous vous invitons à nous envoyer votre demande par mail, accompagnée de photos des chaussures, par mail à l’adresse contact@tilli.fr. Nos artisans reviendront vers vous pour vous conseiller et vous accompagner sur la meilleure couleur à adopter pour votre pièce.'),
      problems: [{
        slug: 'wax',
        label: t('Nettoyer & cirer'),
        locations: [{
          slug: 'wax',
          id: "".concat(pricingVersion, ".shoes-prevent-1")
        }]
      }, {
        slug: 'fullRepare',
        label: t('Rénover le cuir'),
        locations: [{
          slug: 'fullRepare',
          id: "".concat(pricingVersion, ".shoes-prevent-5")
        }]
      }, {
        slug: 'skate',
        label: t('Patiner'),
        locations: [{
          slug: 'skate',
          id: "".concat(pricingVersion, ".shoes-prevent-4")
        }]
      }, {
        slug: 'changeColor',
        label: t('Changer la teinte'),
        locations: [{
          slug: 'changeColor',
          id: ''
        }]
      }]
    }]
  }, {
    name: t('Bottes / Bottines plates'),
    slug: 'boots',
    typesOfWork: [{
      label: t('Entretenir'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'prevent',
      problems: [{
        slug: 'wax',
        label: t('Nettoyer & cirer'),
        locations: [{
          slug: 'wax',
          id: "".concat(pricingVersion, ".shoes-prevent-2")
        }]
      },
      // COMING SOON
      // {
      //   slug: 'waterproofing',
      //   label: 'Imperméabiliser',
      //   locations: [
      //     {
      //       slug: 'waterproofing',
      //       id: `${pricingVersion}.shoes-prevent-5`,
      //     },
      //   ],
      // },
      {
        slug: 'protect',
        label: t('Protéger'),
        question: t('Que souhaitez-vous poser :'),
        withImage: true,
        locations: [{
          slug: 'protect_pads',
          label: t('Des patins'),
          id: "".concat(pricingVersion, ".shoes-prevent-11"),
          image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/skatesShoes.png'
        }, {
          slug: 'protect_irons',
          label: t('Des fers'),
          id: "".concat(pricingVersion, ".shoes-prevent-12"),
          image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/ironsShoes.png'
        }, {
          slug: 'protect_padsAndIrons',
          label: t('Protection complète (patins & fers)'),
          id: "".concat(pricingVersion, ".shoes-prevent-13"),
          image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/completeShoes.png'
        }]
      }, {
        slug: 'shaping',
        label: t('Mettre en forme / Agrandir'),
        question: t('Que souhaitez-vous mettre en forme / agrandir ?'),
        locations: [{
          slug: 'shaping_width',
          label: t('La largeur'),
          id: "".concat(pricingVersion, ".shoes-prevent-8")
        }, {
          slug: 'shaping_kick',
          label: t('Le coup de pied'),
          id: "".concat(pricingVersion, ".shoes-prevent-9")
        }, {
          slug: 'shaping_calf',
          label: t('Le mollet'),
          id: "".concat(pricingVersion, ".shoes-prevent-10")
        }]
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'cure',
      problems: [{
        slug: 'damaged',
        label: t('C‘est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'dirty',
          label: t('C‘est sale / taché / décoloré'),
          id: "".concat(pricingVersion, ".shoes-prevent-1")
        }, {
          slug: 'damagedSole',
          label: t('Semelle extérieure'),
          id: "".concat(pricingVersion, ".shoes-cure-2")
        }, {
          slug: 'damagedHeel',
          label: t('Talon'),
          question: t('Que souhaitez-vous changer :'),
          parts: [{
            slug: 'damagedHeel_bonbout',
            label: t('L\'embout du talon (le bonbout)'),
            id: "".concat(pricingVersion, ".shoes-cure-7")
          }, {
            slug: 'damagedHeel_complete',
            label: t('Le talon entier'),
            id: "".concat(pricingVersion, ".shoes-cure-10")
          }]
        }, {
          slug: 'brokenZip',
          label: t('Zip'),
          id: "".concat(pricingVersion, ".shoes-cure-17"),
          multiple: true
        }, {
          slug: 'eyelet',
          label: t('Oeillets / rivets'),
          id: "".concat(pricingVersion, ".shoes-cure-19"),
          multiple: true
        }, {
          slug: 'damagedInside',
          label: t('A l‘intérieur'),
          question: t('Que souhaitez-vous changer :'),
          withImage: true,
          parts: [{
            slug: 'damagedInside_slides',
            label: t('Les glissoirs'),
            id: "".concat(pricingVersion, ".shoes-cure-15"),
            image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/slidesShoes.png'
          }, {
            slug: 'damagedInside_insole',
            label: t('La semelle intérieure'),
            id: "".concat(pricingVersion, ".shoes-cure-14"),
            image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/insoleShoes.png'
          }]
        }]
      }]
    }, {
      label: t('Rénover'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'recolor',
      message: t(
      // eslint-disable-next-line max-len
      'Pour changer la couleur de vos chaussures ou les patiner, la nouvelle couleur souhaitée doit être plus foncée que la couleur d’origine. Nous vous invitons à nous envoyer votre demande par mail, accompagnée de photos des chaussures, par mail à l’adresse contact@tilli.fr. Nos artisans reviendront vers vous pour vous conseiller et vous accompagner sur la meilleure couleur à adopter pour votre pièce.'),
      problems: [{
        slug: 'wax',
        label: t('Nettoyer & cirer'),
        locations: [{
          slug: 'wax',
          id: "".concat(pricingVersion, ".shoes-prevent-1")
        }]
      }, {
        slug: 'fullRepare',
        label: t('Rénover le cuir'),
        locations: [{
          slug: 'fullRepare',
          id: "".concat(pricingVersion, ".shoes-prevent-7")
        }]
      }, {
        slug: 'skate',
        label: t('Patiner'),
        locations: [{
          slug: 'skate',
          id: "".concat(pricingVersion, ".shoes-prevent-4")
        }]
      }, {
        slug: 'changeColor',
        label: t('Changer la teinte'),
        locations: [{
          slug: 'changeColor',
          id: ''
        }]
      }]
    }]
  }, {
    name: t('Bottes / Bottines à talon'),
    slug: 'heeled_boots',
    typesOfWork: [{
      label: t('Entretenir'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'prevent',
      problems: [{
        slug: 'wax',
        label: t('Nettoyer & cirer'),
        locations: [{
          slug: 'wax',
          id: "".concat(pricingVersion, ".shoes-prevent-2")
        }]
      },
      // COMING SOON
      // {
      //   slug: 'waterproofing',
      //   label: 'Imperméabiliser',
      //   locations: [
      //     {
      //       slug: 'waterproofing',
      //       id: `${pricingVersion}.shoes-prevent-5`,
      //     },
      //   ],
      // },
      {
        slug: 'protect',
        label: t('Protéger'),
        question: t('Que souhaitez-vous poser :'),
        withImage: true,
        locations: [{
          slug: 'protect_pads',
          label: t('Des patins'),
          id: "".concat(pricingVersion, ".shoes-prevent-11"),
          image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/skatesShoes.png'
        }, {
          slug: 'protect_irons',
          label: t('Des fers'),
          id: "".concat(pricingVersion, ".shoes-prevent-12"),
          image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/ironsShoes.png'
        }, {
          slug: 'protect_padsAndIrons',
          label: t('Protection complète (patins & fers)'),
          id: "".concat(pricingVersion, ".shoes-prevent-13"),
          image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/completeShoes.png'
        }]
      }, {
        slug: 'shaping',
        label: t('Mettre en forme / Agrandir'),
        question: t('Que souhaitez-vous mettre en forme / agrandir ?'),
        locations: [{
          slug: 'shaping_width',
          label: t('La largeur'),
          id: "".concat(pricingVersion, ".shoes-prevent-8")
        }, {
          slug: 'shaping_kick',
          label: t('Le coup de pied'),
          id: "".concat(pricingVersion, ".shoes-prevent-9")
        }, {
          slug: 'shaping_calf',
          label: t('Le mollet'),
          id: "".concat(pricingVersion, ".shoes-prevent-10")
        }]
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'cure',
      problems: [{
        slug: 'damaged',
        label: t('C‘est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'dirty',
          label: t('C‘est sale / taché / décoloré'),
          id: "".concat(pricingVersion, ".shoes-prevent-1")
        }, {
          slug: 'damagedSole',
          label: t('Semelle extérieure'),
          id: "".concat(pricingVersion, ".shoes-cure-2")
        }, {
          slug: 'damagedHeel',
          label: t('Talon'),
          question: t('Que souhaitez-vous changer :'),
          parts: [{
            slug: 'damagedHeel_bonbout',
            label: t('L\'embout du talon (le bonbout)'),
            id: "".concat(pricingVersion, ".shoes-cure-7")
          }, {
            slug: 'damagedHeel_complete',
            label: t('Le talon entier'),
            id: "".concat(pricingVersion, ".shoes-cure-10")
          }]
        }, {
          slug: 'brokenZip',
          label: t('Zip'),
          id: "".concat(pricingVersion, ".shoes-cure-17"),
          multiple: true
        }, {
          slug: 'eyelet',
          label: t('Oeillets / rivets'),
          id: "".concat(pricingVersion, ".shoes-cure-19"),
          multiple: true
        }, {
          slug: 'damagedInside',
          label: t('A l‘intérieur'),
          question: t('Que souhaitez-vous changer :'),
          withImage: true,
          parts: [{
            slug: 'damagedInside_slides',
            label: t('Les glissoirs'),
            id: "".concat(pricingVersion, ".shoes-cure-15"),
            image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/slidesShoes.png'
          }, {
            slug: 'damagedInside_insole',
            label: t('La semelle intérieure'),
            id: "".concat(pricingVersion, ".shoes-cure-14"),
            image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/insoleShoes.png'
          }]
        }]
      }]
    }, {
      label: t('Rénover'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'recolor',
      message: t(
      // eslint-disable-next-line max-len
      'Pour changer la couleur de vos chaussures ou les patiner, la nouvelle couleur souhaitée doit être plus foncée que la couleur d’origine. Nous vous invitons à nous envoyer votre demande par mail, accompagnée de photos des chaussures, par mail à l’adresse contact@tilli.fr. Nos artisans reviendront vers vous pour vous conseiller et vous accompagner sur la meilleure couleur à adopter pour votre pièce.'),
      problems: [{
        slug: 'wax',
        label: t('Nettoyer & cirer'),
        locations: [{
          slug: 'wax',
          id: "".concat(pricingVersion, ".shoes-prevent-1")
        }]
      }, {
        slug: 'fullRepare',
        label: t('Rénover le cuir'),
        locations: [{
          slug: 'fullRepare',
          id: "".concat(pricingVersion, ".shoes-prevent-7")
        }]
      }, {
        slug: 'skate',
        label: t('Patiner'),
        locations: [{
          slug: 'skate',
          id: "".concat(pricingVersion, ".shoes-prevent-4")
        }]
      }, {
        slug: 'changeColor',
        label: t('Changer la teinte'),
        locations: [{
          slug: 'changeColor',
          id: ''
        }]
      }]
    }]
  }, {
    name: t('Sneakers'),
    slug: 'sneakers',
    typesOfWork: [{
      label: t('Entretenir'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'prevent',
      problems: [{
        slug: 'wax',
        label: t('Nettoyer & cirer'),
        locations: [{
          slug: 'wax',
          id: "".concat(pricingVersion, ".shoes-prevent-1")
        }]
      },
      // COMING SOON
      // {
      //   slug: 'waterproofing',
      //   label: 'Imperméabiliser',
      //   locations: [
      //     {
      //       slug: 'waterproofing',
      //       id: `${pricingVersion}.shoes-prevent-5`,
      //     },
      //   ],
      // },
      {
        slug: 'protect',
        label: t('Protéger'),
        question: t('Que souhaitez-vous poser :'),
        withImage: true,
        locations: [{
          slug: 'protect_pads',
          label: t('Des patins'),
          id: "".concat(pricingVersion, ".shoes-prevent-11"),
          image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/skatesShoes.png'
        }, {
          slug: 'protect_irons',
          label: t('Des fers'),
          id: "".concat(pricingVersion, ".shoes-prevent-12"),
          image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/ironsShoes.png'
        }, {
          slug: 'protect_padsAndIrons',
          label: t('Protection complète (patins & fers)'),
          id: "".concat(pricingVersion, ".shoes-prevent-13"),
          image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/completeShoes.png'
        }]
      }, {
        slug: 'shaping',
        label: t('Mettre en forme / Agrandir'),
        question: t('Que souhaitez-vous mettre en forme / agrandir ?'),
        locations: [{
          slug: 'shaping_width',
          label: t('La largeur'),
          id: "".concat(pricingVersion, ".shoes-prevent-8")
        }, {
          slug: 'shaping_kick',
          label: t('Le coup de pied'),
          id: "".concat(pricingVersion, ".shoes-prevent-9")
        }]
      }]
    }, {
      label: t('Réparer'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'cure',
      problems: [{
        slug: 'damaged',
        label: t('C‘est abîmé'),
        question: t('À quel endroit est-ce abîmé ?'),
        locations: [{
          slug: 'dirty',
          label: t('C‘est sale / taché / décoloré'),
          id: "".concat(pricingVersion, ".shoes-prevent-1")
        }, {
          slug: 'damagedSole',
          label: t('Semelle extérieure'),
          id: "".concat(pricingVersion, ".shoes-cure-2")
        }, {
          slug: 'damagedHeel',
          label: t('Talon'),
          question: t('Que souhaitez-vous changer :'),
          parts: [{
            slug: 'damagedHeel_bonbout',
            label: t('L\'embout du talon (le bonbout)'),
            id: "".concat(pricingVersion, ".shoes-cure-7")
          }, {
            slug: 'damagedHeel_complete',
            label: t('Le talon entier'),
            id: "".concat(pricingVersion, ".shoes-cure-10")
          }]
        }, {
          slug: 'brokenZip',
          label: t('Zip'),
          id: "".concat(pricingVersion, ".shoes-cure-17"),
          multiple: true
        }, {
          slug: 'eyelet',
          label: t('Oeillets / rivets'),
          id: "".concat(pricingVersion, ".shoes-cure-19"),
          multiple: true
        }, {
          slug: 'damagedInside',
          label: t('A l‘intérieur'),
          question: t('Que souhaitez-vous changer :'),
          withImage: true,
          parts: [{
            slug: 'damagedInside_slides',
            label: t('Les glissoirs'),
            id: "".concat(pricingVersion, ".shoes-cure-15"),
            image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/slidesShoes.png'
          }, {
            slug: 'damagedInside_insole',
            label: t('La semelle intérieure'),
            id: "".concat(pricingVersion, ".shoes-cure-14"),
            image: 'https://res.cloudinary.com/tilli/image/upload/v1727189860/tilli-core/insoleShoes.png'
          }]
        }, {
          slug: 'untidy',
          label: t('Couture décousue'),
          id: "".concat(pricingVersion, ".shoes-cure-28")
        }]
      }]
    }, {
      label: t('Rénover'),
      subLabel: t('Prolonger la durée de vie'),
      slug: 'recolor',
      message: t(
      // eslint-disable-next-line max-len
      'Pour changer la couleur de vos chaussures ou les patiner, la nouvelle couleur souhaitée doit être plus foncée que la couleur d’origine. Nous vous invitons à nous envoyer votre demande par mail, accompagnée de photos des chaussures, par mail à l’adresse contact@tilli.fr. Nos artisans reviendront vers vous pour vous conseiller et vous accompagner sur la meilleure couleur à adopter pour votre pièce.'),
      problems: [{
        slug: 'wax',
        label: t('Nettoyer & cirer'),
        locations: [{
          slug: 'wax',
          id: "".concat(pricingVersion, ".shoes-prevent-1")
        }]
      }, {
        slug: 'fullRepare',
        label: t('Rénover le cuir'),
        locations: [{
          slug: 'fullRepare',
          id: "".concat(pricingVersion, ".shoes-prevent-6")
        }]
      }, {
        slug: 'skate',
        label: t('Patiner'),
        locations: [{
          slug: '',
          id: ''
        }]
      }, {
        slug: 'changeColor',
        label: t('Changer la teinte'),
        locations: [{
          slug: '',
          id: ''
        }]
      }]
    }]
  }];
};
var _default = exports["default"] = getTreePackage;